module.exports = __webpack_public_path__ + "img/badge-list-thumb-034.b68d5473.png";